if (!customElements.get('topics-announcement')) {
  customElements.define('topics-announcement', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.();
      const controller = new AbortController();
      const opts = { signal: controller.signal };
      const slides = [...this.querySelectorAll('[data-notice]')];
      const message = this.querySelector('.tf-notices-message');
      const pause = this.querySelector('[data-notice-pause]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0, timer, paused = reduced.matches, hovering = false;
      const stop = () => clearInterval(timer);
      const show = (step, manual = false) => {
        message.setAttribute('aria-live', manual ? 'polite' : 'off');
        index = (index + step + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== index; });
      };
      const schedule = () => {
        stop();
        if (!paused && !hovering && !document.hidden && !this.contains(document.activeElement)) timer = setInterval(() => show(1), 5000);
      };
      const updatePause = () => {
        pause.textContent = paused ? '▷' : 'Ⅱ';
        pause.setAttribute('aria-label', paused ? 'Automatisch wisselen starten' : 'Automatisch wisselen pauzeren');
      };
      this.querySelectorAll('button').forEach(button => { button.hidden = false; });
      this.querySelector('[data-notice-prev]').addEventListener('click', () => { show(-1, true); schedule(); }, opts);
      this.querySelector('[data-notice-next]').addEventListener('click', () => { show(1, true); schedule(); }, opts);
      pause.addEventListener('click', () => { paused = !paused; updatePause(); schedule(); }, opts);
      this.addEventListener('mouseenter', () => { hovering = true; stop(); }, opts);
      this.addEventListener('mouseleave', () => { hovering = false; schedule(); }, opts);
      this.addEventListener('focusin', stop, opts);
      this.addEventListener('focusout', () => queueMicrotask(schedule), opts);
      document.addEventListener('visibilitychange', schedule, opts);
      reduced.addEventListener('change', () => { paused = reduced.matches; updatePause(); schedule(); }, opts);
      this.cleanup = () => { stop(); controller.abort(); };
      show(0); updatePause(); schedule();
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}
